import { useState, useContext, useEffect } from "react";
import { Formik, Form as FormikForm, Field, ErrorMessage } from "formik";
import { Form, Row, Col } from "react-bootstrap";
import * as Yup from "yup";
import { UserDataContext } from "../components/UserDataContext";
import { registerLocale } from "react-datepicker";
import { format } from "date-fns";
import "../components/button.css";
import { TextField, Select, InputLabel } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { pl } from "date-fns/locale";
import { marginBottom } from "../App";
import Alerts from "../components/Alerts";
import Button from "@mui/material/Button";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FilesData from "./FilesData";
import SaveIcon from "@mui/icons-material/Save";
import { useNavigate } from "react-router-dom";
import { TaskContext } from "../components/TaskContext";
import { apiRequest } from "../components/Config";

const validationSchema = Yup.object().shape({
  typeoftask: Yup.number().required("Nie wybrano źródła zlecenia."),
  buildingPart: Yup.number().required("Nie wybrano tematu zlecenia."),
  content: Yup.string().required("Wpisz treść zlecenia."),
  reporter: Yup.string().required(
    "Nazwisko i Imię lub nazwa Firmy są wymagane."
  ),
  location: Yup.string().required("Adres lokalizacji obiektu jest wymagany."),
  selectedDate: Yup.date().nullable().required("Data jest wymagana."),
  completionDate: Yup.date()
    .nullable()
    .required("Termin realizacji jest wymagany."),
});

export default function AddTask() {
  registerLocale("pl", pl);
  const navigate = useNavigate();
  const { userData } = useContext(UserDataContext);
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [typeoftasks, setTypeoftasks] = useState([]);
  const [buildingParts, setBuildingParts] = useState([]);
  const { taskId, setTaskId } = useContext(TaskContext);
  const today = new Date();
  const initialValues = {
    typeoftask: "",
    buildingPart: "",
    reporter: "",
    reporterMail: "",
    reporterPhone: "",
    location: "",
    content: "",
    selectedDate: new Date(new Date()),
    receiveData: "",
    completionDate: new Date(today.setMonth(today.getMonth() + 1)),
  };

  useEffect(() => {
    if (userData) {
      setTaskId(0);
      const fetchData = async () => {
        try {
          const response = await apiRequest("buildingparts");
          setBuildingParts(response);
        } catch (error) {
          //setError(error.message);
        }
      };
      fetchData();
    }
  }, [userData]);

  useEffect(() => {
    if (userData) {
      const fetchData = async () => {
        try {
          const response = await apiRequest("typeoftasks");

          setTypeoftasks(response);
        } catch (error) {
          console.error(error.message);
        }
      };
      fetchData();
    }
  }, [userData]);

  const handleSubmit = async (values, { isSubmitting, resetForm }) => {
    const formattedSelected = format(values.selectedDate, "yyyy-MM-dd");
    const formattedCompletion = format(values.completionDate, "yyyy-MM-dd");

    values["receiveData"] = formattedSelected;
    values["completionData"] = formattedCompletion;
    //console.log("VALUES: ", values);

    try {
      const response = await apiRequest("newtask", "POST", values);
      //console.log("RD: ", response);

      if (response.error_msg === 200) {
        setTaskId(response.taskId);
        setShowApiResponse(true);
        setApiResponse({
          title: "Sukces",
          severity: "success",
          info: "Zlecenie dodane!",
        });
        resetForm();
      }
      if (response.error_msg === 409) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Uwaga",
          severity: "error",
          info: "Próbujesz zarejestrować istniejące zlecenie!",
        });
      }
    } catch (error) {
      console.error("Błąd: ", error);
    }
  };

  const handleExit = () => {
    navigate("/menu");
  };

  return (
    <div>
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, isSubmitting, setFieldValue }) => (
          <ThemeProvider theme={theme}>
            <FormikForm>
              <Row>
                <Col md="4" style={{ marginBottom }}>
                  <Box sx={{ minWidth: 120 }}>
                    <Form.Group controlId="formType">
                      <InputLabel id="typeoftask-label">
                        Źródło zlecenia
                      </InputLabel>
                      <Select
                        id="typeoftask"
                        name="typeoftask"
                        value={values.typeoftask}
                        label="Zlecenie"
                        onChange={(e) =>
                          setFieldValue(
                            "typeoftask",
                            parseInt(e.target.value, 10)
                          )
                        }
                        fullWidth
                      >
                        {typeoftasks.map((type) => (
                          <MenuItem key={type.id} value={type.id}>
                            {type.typeoftask}
                          </MenuItem>
                        ))}
                      </Select>
                    </Form.Group>
                  </Box>
                  <ErrorMessage
                    name="typeoftask"
                    component="div"
                    className="text-danger"
                  />
                </Col>
                <Col md="4" style={{ marginBottom }}>
                  <Box sx={{ minWidth: 120 }}>
                    <Form.Group controlId="formBuildingPart">
                      <InputLabel id="buildingPart-label">
                        Czego dotyczy
                      </InputLabel>
                      <Select
                        id="buildingPart"
                        name="buildingPart"
                        value={values.buildingPart}
                        labelId="buildingPart-label"
                        onChange={(e) =>
                          setFieldValue(
                            "buildingPart",
                            parseInt(e.target.value, 10)
                          )
                        }
                        fullWidth
                      >
                        {buildingParts.map((part) => (
                          <MenuItem key={part.id} value={part.id}>
                            {part.buildingpart}
                          </MenuItem>
                        ))}
                      </Select>
                    </Form.Group>
                  </Box>
                  <ErrorMessage
                    name="buildingPart"
                    component="div"
                    className="text-danger"
                  />
                </Col>
                <Col md="4" style={{ marginBottom }}>
                  <Form.Group controlId="formLocation">
                    <InputLabel id="location-label">
                      Lokalizacja obiektu
                    </InputLabel>
                    <Field
                      as={TextField}
                      type="text"
                      name="location"
                      fullWidth
                    />
                  </Form.Group>
                  <ErrorMessage
                    name="location"
                    component="div"
                    className="text-danger"
                  />
                </Col>
              </Row>
              <Row>
                <Col md="4" style={{ marginBottom }}>
                  <Form.Group controlId="formReporter">
                    <InputLabel id="reporter-label">Zleceniodawca</InputLabel>
                    <Field
                      as={TextField}
                      type="text"
                      name="reporter"
                      fullWidth
                    />
                  </Form.Group>
                  <ErrorMessage
                    name="reporter"
                    component="div"
                    className="text-danger"
                  />
                </Col>
                <Col md="4" style={{ marginBottom }}>
                  <Form.Group controlId="formReporterMail">
                    <InputLabel id="reporterMail-label">
                      Mail zleceniodawcy
                    </InputLabel>
                    <Field
                      as={TextField}
                      type="text"
                      name="reporterMail"
                      fullWidth
                    />
                  </Form.Group>
                </Col>

                <Col md="4" style={{ marginBottom }}>
                  <Form.Group controlId="formReporter">
                    <InputLabel id="reporterPhone-label">
                      Telefon zleceniodawcy
                    </InputLabel>
                    <Field
                      as={TextField}
                      type="text"
                      name="reporterPhone"
                      fullWidth
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md="4" style={{ marginBottom }}>
                  <Form.Group controlId="formContent">
                    <InputLabel id="reporterPhone-label">
                      Treść zlecenia
                    </InputLabel>
                    <Field
                      as={TextField}
                      type="text"
                      name="content"
                      fullWidth
                      multiline
                      minRows={3}
                      variant="outlined"
                    />
                  </Form.Group>
                  <ErrorMessage
                    name="content"
                    component="div"
                    className="text-danger"
                  />
                </Col>
                <Col md="4" style={{ marginBottom }}>
                  <Form.Group controlId="formDate">
                    <InputLabel id="reporterPhone-label">
                      Data rejestracji zlecenia
                    </InputLabel>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={pl}
                    >
                      <DatePicker
                        value={values.selectedDate}
                        onChange={(date) => setFieldValue("selectedDate", date)}
                        dateFormat="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        slotProps={{ textField: { variant: "outlined" } }}
                        fullWidth
                      />
                    </LocalizationProvider>
                  </Form.Group>
                </Col>
                <Col md="4" style={{ marginBottom }}>
                  <Form.Group controlId="formCompletionDate">
                    <InputLabel id="reporterPhone-label">
                      Termin realizacji
                    </InputLabel>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={pl}
                    >
                      <DatePicker
                        value={values.completionDate}
                        onChange={(dateCompletion) =>
                          setFieldValue("completionDate", dateCompletion)
                        }
                        dateFormat="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        slotProps={{ textField: { variant: "outlined" } }}
                      />
                    </LocalizationProvider>
                  </Form.Group>
                </Col>
                <Col md="2">
                  <ErrorMessage
                    name="completionDate"
                    component="div"
                    className="text-danger"
                  />
                </Col>
              </Row>

              <hr></hr>
              <Row>
                <Col md="2">
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    <SaveIcon />
                    Rejestruj
                  </Button>
                </Col>
                <Col md="4">
                  <Button variant="outlined" onClick={handleExit}>
                    Powrót do menu
                  </Button>
                </Col>
              </Row>
            </FormikForm>
          </ThemeProvider>
        )}
      </Formik>

      {taskId > 0 && <FilesData />}
    </div>
  );
}
